import { handleResponse } from "../utils/handle-response";

export const reportesService = {
    empresasGeneral,
    empresasGeneralCompanyId,
    empresasGeneralCompanyFilter,
    completitudGeneral,
    calidadGeneral,
    calidadTipoInstalacion,
    completitudTipoInstalacion,
    empresasFiltered,
    instalacionesFiltered
}

function sortArrays(a, b) {
    let compareA = a.id_empresa.replace("P_", '')
    let compareB = a.id_empresa.replace("P_", '')
    return compareA - compareB
}

function empresasGeneral(filterParams) {
    const url = process.env.API_URL + "/api/v1/reportes/completitud-calidad-empresa/"
    
    return fetch(url)
            .then(handleResponse)
            .then( x => {
                var re = new RegExp(filterParams.filter.search)
                x = x.filter( y => {
                    const { nombre_empresa } = y 
                    return re.test(nombre_empresa)
                })
                let totalResults = x.length
                x.sort(sortArrays)
                x = x.slice(filterParams.pagination.perPage * filterParams.pagination.page - filterParams.pagination.perPage, filterParams.pagination.perPage * filterParams.pagination.page)
                return Promise.resolve({ empresas: x, totalResults });
            }).catch((error)=>{
               return Promise.reject(error)    
    }); 
}

function empresasGeneralCompanyId(id) {
    const url = process.env.API_URL + "/api/v1/reportes/completitud-calidad-empresa/?empresa_id=" + id
    
    
    return fetch(url)
            .then(handleResponse)
            .then( x => {
                x.sort(sortArrays)
                return Promise.resolve({ empresas: x, totalResults: 1 });
            }).catch((error)=>{
               return Promise.reject(error)    
    }); 
}

function empresasGeneralCompanyFilter(filterParams) {
    const url = process.env.API_URL + "/api/v1/reportes/completitud-calidad-empresa/"
    
    return fetch(url)
            .then(handleResponse)
            .then( x => {
                x.sort(sortArrays)
                return Promise.resolve({ empresas: x });
            }).catch((error)=>{
               return Promise.reject(error)    
    }); 
}

function completitudGeneral(idEmpresa) {
    const url = idEmpresa   ? process.env.API_URL + "/api/v1/reportes/completitud-general/?empresa_id=" + idEmpresa 
                            : process.env.API_URL + "/api/v1/reportes/completitud-general/"
    
    return fetch(url)
            .then(handleResponse)
            .then( dataSetCompletitud => {
                return Promise.resolve( dataSetCompletitud[0] )
            })
}

function calidadGeneral(idEmpresa) {
    const url = idEmpresa   ? process.env.API_URL + "/api/v1/reportes/calidad-general/?empresa_id=" + idEmpresa 
                            : process.env.API_URL + "/api/v1/reportes/calidad-general/"
    return fetch(url)
            .then(handleResponse)
            .then( dataSetCalidadGeneral => {
                return Promise.resolve( dataSetCalidadGeneral[0] )
            })

}

function calidadTipoInstalacion(idEmpresa) {
    const url = idEmpresa   ? process.env.API_URL + "/api/v1/reportes/calidad-tipo-instalacion-general/?empresa_id=" + idEmpresa 
                            : process.env.API_URL + "/api/v1/reportes/calidad-tipo-instalacion-general/"
    
    return fetch(url)
            .then(handleResponse)
            .then( dataSetTipoInstalacion => {
                return Promise.resolve( dataSetTipoInstalacion )
            })
}

function completitudTipoInstalacion(idEmpresa) {
    const url = idEmpresa   ? process.env.API_URL + "/api/v1/reportes/completitud-tipo-instalacion-general/?empresa_id=" + idEmpresa 
                            : process.env.API_URL + "/api/v1/reportes/completitud-tipo-instalacion-general/"
    return fetch(url)
            .then(handleResponse)
            .then( dataSetCompletitudTipoInstalacion => {
                return Promise.resolve( dataSetCompletitudTipoInstalacion )
            })
}



function empresasFiltered() {
    const url = "https://api-infotecnica.coordinador.cl/v1/grado-de-cumplimiento?empresa_id=70"
    
    return fetch(url)
            .then(handleResponse)
            .then( x => {
                return Promise.resolve(x);
            }).catch((error)=>{
               return Promise.reject(error)    
    }); 
}

function instalacionesFiltered() {
    const url = "https://api-infotecnica.coordinador.cl/v1/empresas/completitud-calidad/instalaciones/?empresa_id=70"

    return fetch(url)
            .then(handleResponse)
            .then( x => {
                return Promise.resolve(x);
            }).catch((error)=>{
               return Promise.reject(error)    
    });
}